import { useState,useEffect, useRef } from "react";
import Buttons from "../buttons/buttons";
import './ask-ai.css';
import AIChatBody from "./ask-ai-chat";
import Tooltip from "../tooltip/tooltips";
import { CHAT_ID_PARAM, PENDING_CHAT_KEY } from "../../shared/constants/globalConstants";

const UI_STATE_KEY = 'clutch_bot_ui_state';
const MAIN_WRAPPER_ID = 'mainwrapper';
const MAIN_WRAPPER_CHAT_CLASS = 'chatbot-open';
const COLLAPSE_MENU_EVENT = 'collapse-side-menu';
const EXPAND_MENU_EVENT = 'expand-side-menu';

export default function AskAIButton(props: any) {
    const AskClutchBotHeaderRef = useRef<HTMLDivElement>(null);
    const [isOpen, setIsOpen] = useState<boolean>(() => {
        if (typeof window === 'undefined') return false;

        const params = new URLSearchParams(window.location.search);
        // Check for the URL param OR the Bridge Key from sessionStorage
        const hasChatId = params.has(CHAT_ID_PARAM) || 
                          Boolean(sessionStorage.getItem(PENDING_CHAT_KEY));
        
        if (hasChatId) return true; // Force open if link is shared
        
        try {
            const saved = localStorage.getItem(UI_STATE_KEY);
            return saved ? (JSON.parse(saved)?.isOpen ?? false) : false;
        } catch { return false; }
    });
    
    const [isFullscreen, setIsFullscreen] = useState(() => {
        try {
            const saved = localStorage.getItem(UI_STATE_KEY);
            return saved ? JSON.parse(saved).isFullscreen : false;
        } catch { return false; }
    })

    useEffect(() => {
        localStorage.setItem(UI_STATE_KEY, JSON.stringify({ isOpen, isFullscreen }))
        if(AskClutchBotHeaderRef.current && !isFullscreen){
            AskClutchBotHeaderRef.current?.focus()
        }
    }, [isOpen, isFullscreen])
   const isLargeScreen = () => window.innerWidth >= 2200
    useEffect(() => {
        if (!isLargeScreen()) return
        const mainWrapper = document.getElementById(MAIN_WRAPPER_ID)
        if (!mainWrapper) return
        mainWrapper.classList.toggle(MAIN_WRAPPER_CHAT_CLASS, isOpen)
        return () => {
            mainWrapper.classList.remove(MAIN_WRAPPER_CHAT_CLASS)
        }
    }, [isOpen])

    useEffect(() => {
        if (!isLargeScreen()) return
        const handleExpandMenu = () => {
           if (isLargeScreen()) {
            setIsOpen(false)
            setIsFullscreen(false)
           }
        }
        window.addEventListener(EXPAND_MENU_EVENT, handleExpandMenu)
        return () => {
            window.removeEventListener(EXPAND_MENU_EVENT, handleExpandMenu)
        }
    }, [])
    

    const toggleChatbot = () => {
        if (isOpen) {
            setIsOpen(false);
            setIsFullscreen(false);
            return;
        }

        // Open chatbot
        setIsOpen(true);

        // On ultra-wide screens, close the menu
        if (window.innerWidth >= 2200) {
            window.dispatchEvent(new CustomEvent(COLLAPSE_MENU_EVENT));
        }
    };
    const FullscreenChat = () => {
        setIsFullscreen(!isFullscreen);
    }

    const handleNewChat = () => {
        window.dispatchEvent(new CustomEvent("new-chat-or-clear-chat"));
    };

    return (
        <div>
            <div className="d-flex">
                <Buttons
                    label="Ask Clutch Bot"
                    ariaLabel="Ask Clutch Bot"
                    icon={`${props?.ismobile ? 'icon-rhybus-ai font-16' : 'icon-ask-chatbot me-1 font-13'}`}
                    className="btn-md sora-semibold font-lg-13 font-0 ask-anew-ai-button px-3"
                    onClick={() => { toggleChatbot(); }}
                />
                <div className='divider vertical d-none d-block-md ms-2'></div>
            </div>
             {isOpen && <div className={`ask-ai-chatbox ${isOpen ? 'open' : ''} ${isFullscreen && window.innerWidth > 1023 ? 'fullscreen-chat' : ''}`}>
                <div className="ask-ai-header d-flex align-items-center p-lg-4 border-bottom-1 gap-2">
                    <div className="d-flex gap-2 align-items-center me-auto">
                        <span className="icon-ask-chatbot me-1 font-30 text-color-61"></span>
                        <div>
                            <div className="sora-semibold font-20 text-color-1 pe-1" tabIndex={0} ref={AskClutchBotHeaderRef} aria-label="Ask Clutch Bot">
                                Ask Clutch Bot
                                <Tooltip content="Your smart assistant for every T&R step." position="top">
                                    <span className="icon-rb-info color-primary ps-1"></span>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                    
                    <div className="d-flex align-items-center">
                        
                        <button 
                            className="header-new-chat-btn" 
                            onClick={handleNewChat}
                            title="Start a new conversation"
                        >
                            <span className="icon-rb-add"></span> {/* Or icon-rb-reset-all / icon-rb-add*/}
                        </button>

                        {!props?.ismobile &&
                            <Buttons aria-label={isFullscreen ? "Collapse chat" : "Expand chat"}
                                icon={`color-primary bold ${isFullscreen ? 'icon-rb-arrow-angle-shrink' : 'icon-rb-arrow-angle-expand'} font-14`}
                                aria-expanded={isFullscreen}
                                className="font-12 ms-1"
                                onClick={() => FullscreenChat()} 
                                onKeyDown={(e:any) => { if (e.key === 'Enter' || e.key === ' ') FullscreenChat(); }} />}
                        
                        <Buttons
                            label="close"
                            className="lh-normal font-0 bgcolor-31 border-radius p-2 ms-2"
                            icon="icon-rb-close font-10"
                            onClick={() => { toggleChatbot(); }}
                            onKeyDown={(e: any) => { if (e.key === 'Enter' || e.key === ' ') { toggleChatbot(); } }} />
                    </div>
                </div>
                <AIChatBody />
            </div>}
        </div>
    )
}